import { type ReactNode } from 'react'
import { AuthProvider as BaseAuthProvider } from '@betstarters/auth'
import api from '@/api/client'

export function AuthProvider({ children }: { children: ReactNode }) {
  return (
    <BaseAuthProvider config={{ api, enableImpersonation: true }}>
      {children}
    </BaseAuthProvider>
  )
}
